<template>
	<div class="video-row">
		<div class="content-col">
			<slot></slot>
		</div>
		<div class="video-col">
			<FunnelVideoCard
				:video-id="video.id"
				:title="video.title"
				:description="video.description"
				:start="video.start || 0"
				:end="video.end || 0"
			/>
		</div>
	</div>
</template>

<script>
import FunnelVideoCard from "@/console-new/components/shared/FunnelVideoCard.vue";

export default {
	setup() {

	},
	name: "StepsBottomSheetVideoRow",
	components: {FunnelVideoCard},
	props: {
		video: {
			type: Object,
			required: true,
			validator(value) {
				return value && value.hasOwnProperty('id') && value.hasOwnProperty('title') && value.hasOwnProperty('description');
			}
		}
	},
}

</script>

<style scoped lang="scss">
.video-row {
	display: flex;
	width: 100%;

	.video-col, .content-col {
		display: flex;
		flex-direction: column;
		width: 50%;
	}
	.content-col {
		justify-content: center;
	}
	.video-col {
		align-items: center;
		justify-content: flex-start;
	}

	@media (max-width: 768px) {
		flex-direction: column;

		.video-col, .content-col {
			width: 100%;
		}
		.video-col {
			align-items: flex-start;
			margin-top: 20px;
		}
	}
}
</style>